import { subDays } from 'date-fns';

import { PeriodType } from '../../../widget/date-range.widget.model';
import { periodTypeDays } from '../const/period-type-days.const';
import { ViewSummaryPeriodType } from '../model/view-summary-period-type.model';

export function defaultViewSummaryPeriodType(): ViewSummaryPeriodType {
    return {
        periodTypeId: PeriodType.ROLLING_30,
        startDate: subDays(new Date(), periodTypeDays[PeriodType.ROLLING_30]),
        endDate: new Date(),
        isDefault: true,
    };
}
